export default __webpack_public_path__ + "static/media/tocaya.91b8b251.png";